import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import PaymentResult from '../views/PaymentResult.vue';
import TicketDownload from '../views/TicketDownload.vue';
const SaleTicketView = () => import('../views/SaleTicketView.vue');

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		path: '/reference/:purchaseReference',
		name: 'TicketDownload',
		component: TicketDownload
	},
	{
		path: '/show/:hash',
		name: 'show',
		props: { useCaseOnlyHash: true },
		component: SaleTicketView
	},
	{
		path: '/show/:hash/us/:hash_user',
		name: 'showuser',
		props: { useCaseUser: true },
		component: SaleTicketView
	},
	{
		path: '/show/:hash/inv/:hash_invitador',
		name: 'showinv',
		props: { useCaseInvitador: true },
		component: SaleTicketView
	},
	{
		path: '/order/:result',
		name: 'orderresult',
		component: PaymentResult
	},
	{
		path: '*',
		redirect: '/'
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
